import autotask_icon from "../assets/img/autotask_logo.png";
import datto_icon from "../assets/img/datto_icon.png";
import superoffice_icon from "../assets/img/superops_icon.png";
import m365_icon from "../assets/img/Microsoft-365.svg";
import google_icon from "../assets/img/google_icon.png";
import threatlocker_icon from "../assets/img/threatlocker_icon.png";
import zoom_icon from "../assets/img/zoom-app.svg";
import zapier_icon from "../assets/img/zapier_icon.png";
import slack_icon from "../assets/img/slack-new-logo.svg";
import sherweb_icon from "../assets/img/sherweb_logo.svg";
import onepassword_icon from "../assets/icons/onepassword.png";
import superops_icon from "../assets/img/superops_ai_logo.jpg";
import dropbox_icon from "../assets/img/dropbox-2.svg";
import quickbooks_icon from "../assets/img/quickbooks-1.svg";
import box_icon from "../assets/img/box-39.svg";
import ninja_icon from "../assets/img/ninjaone-icon.png";
import itgl_icon from "../assets/img/itglue_logo.png";
import hudu_icon from "../assets/img/hudu_logo.png";
import jotform_icon from "../assets/img/jotform_logo.png";
import acronis_icon from "../assets/img/acronis_logo.png";
import connectwise_icon from "../assets/icons/connectwise.jpg";
import halo_psa_icon from "../assets/icons/halo_psa.png";
import huntress_icon from "../assets/img/huntress_logo.jpg";
import syncro_icon from "../assets/img/syncro_logo.webp";
import connectwise_automate_icon from "../assets/img/connectwise_automate_logo.png";
import nable_icon from "../assets/img/nable_logo.png";
import addigy_icon from "../assets/img/addigy_logo.webp";
import proofpoint_icon from "../assets/img/proofpoint_logo.png";
import sentinelone_icon from "../assets/img/sentinelone_logo.png";
import unifi_icon from "../assets/img/unifi_logo.svg";
import auvik_icon from "../assets/img/auvik_logo.png";
import meraki_icon from "../assets/img/meraki_logo.svg";
import saas_alerts_icon from "../assets/img/saas_alerts_logo.webp";
import timezest_icon from "../assets/img/timezest_logo.png";

// Default icon for unknown applications
import default_icon from "../assets/img/autotask_icon.png";

const connectorLogos: { [key: string]: string } = {
  Autotask: autotask_icon,
  autotask: autotask_icon,
  Datto: datto_icon,
  datto: datto_icon,
  SuperOffice: superoffice_icon,
  m365: m365_icon,
  google: google_icon,
  gworkspace: google_icon,
  ThreatLocker: threatlocker_icon,
  zoom: zoom_icon,
  Zapier: zapier_icon,
  slack: slack_icon,
  sherweb: sherweb_icon,
  onepassword: onepassword_icon,
  superops: superops_icon,
  dropbox: dropbox_icon,
  quickbooks: quickbooks_icon,
  box: box_icon,
  ninjaone: ninja_icon,
  ITGlue: itgl_icon,
  itglue: itgl_icon,
  hudu: hudu_icon,
  Hudu: hudu_icon,
  jotform: jotform_icon,
  JotForm: jotform_icon,
  Jotform: jotform_icon,
  Acronis: acronis_icon,
  Connectwise: connectwise_icon,
  connectwise: connectwise_icon,
  Halo: halo_psa_icon,
  halo: halo_psa_icon,
  Huntress: huntress_icon,
  nable: nable_icon,
  Nable: nable_icon,
  "n-able": nable_icon,
  "N-able": nable_icon,
};

const connectorDescriptions: { [key: string]: string } = {
  autotask:
    "Professional services automation for tickets, queues, projects, and billing. Theo reads and updates tickets, posts time entries, and drives Auto Mode from this connection.",
  Autotask:
    "Professional services automation for tickets, queues, projects, and billing. Theo reads and updates tickets, posts time entries, and drives Auto Mode from this connection.",
  Datto:
    "Remote monitoring and management for endpoints. Theo reads devices and alerts, runs scripts, and opens secure shell sessions from this connection.",
  datto:
    "Remote monitoring and management for endpoints. Theo reads devices and alerts, runs scripts, and opens secure shell sessions from this connection.",
  SuperOffice:
    "SuperOffice is a CRM software that helps businesses manage their customer relationships and sales processes.",
  "Microsoft 365":
    "Microsoft 365 is a cloud-based productivity suite that helps businesses manage their email, calendar, and documents.",
  google:
    "Google Workspace identity, mail, calendar, and Drive for end users. Theo manages users and groups, mail flow, and shared resources from this connection.",
  gworkspace:
    "Google Workspace identity, mail, calendar, and Drive for end users. Theo manages users and groups, mail flow, and shared resources from this connection.",
  ThreatLocker:
    "ThreatLocker is a security software that helps businesses protect their data.",
  zoom: "Zoom is a video conferencing software that helps businesses manage their video conferencing.",
  Zapier:
    "Zapier is a workflow automation software that helps businesses automate their workflows.",
  slack:
    "Team chat where Theo answers questions, posts ticket updates, and notifies technicians. Connect it per customer workspace.",
  sherweb:
    "Cloud marketplace for Microsoft and third-party subscriptions. Theo looks up catalog items, places orders, and tracks billing from this connection.",
  onepassword:
    "Team password vaults, items, and sharing. Theo looks up and manages vault items on behalf of technicians from this connection.",
  m365: "Microsoft 365 identity, mail, calendar, and Teams for end users. Theo manages users and groups, mailboxes, and licenses from this connection.",
  superops:
    "Professional services automation plus RMM for tickets, queues, and endpoints. Theo reads and updates tickets and acts on devices from this connection.",
  quickbooks:
    "Quickbooks is a accounting software that helps businesses manage their accounting.",
  box: "Box is a cloud-based content management and file sharing service for businesses.",
  dropbox:
    "Dropbox is a cloud-based file hosting service that allows users to store and share files and folders.",
  ninjaone:
    "Ticketing plus remote monitoring and management in one platform. Theo reads and updates tickets, monitors devices and alerts, and runs scripts from this connection.",
  ITGlue:
    "IT documentation hub for passwords, runbooks, and asset records. Theo searches articles and keeps documentation in context from this connection.",
  itglue:
    "IT documentation hub for passwords, runbooks, and asset records. Theo searches articles and keeps documentation in context from this connection.",
  hudu:
    "IT documentation hub for articles, passwords, and asset layouts. Theo searches the knowledge base and keeps documentation in context from this connection.",
  Hudu:
    "IT documentation hub for articles, passwords, and asset layouts. Theo searches the knowledge base and keeps documentation in context from this connection.",
  Acronis:
    "Acronis is a cyber protection and backup software that helps businesses safeguard their data and systems.",
  Connectwise:
    "Professional services automation for tickets, boards, projects, and agreements. Theo reads and updates tickets and drives Auto Mode from this connection.",
  connectwise:
    "Professional services automation for tickets, boards, projects, and agreements. Theo reads and updates tickets and drives Auto Mode from this connection.",
  Halo: "Service desk and IT operations platform for tickets, queues, and SLAs. Theo reads and updates tickets and drives Auto Mode from this connection.",
  halo: "Service desk and IT operations platform for tickets, queues, and SLAs. Theo reads and updates tickets and drives Auto Mode from this connection.",
  Huntress:
    "Huntress is a cybersecurity platform that helps businesses detect, respond to, and prevent cyber threats.",
  nable:
    "Remote monitoring and management for endpoints. Theo reads devices and alerts, runs scripts, and tracks device health from this connection.",
};

// Application name mapping for display
const appNameMapping: { [key: string]: string } = {
  slack: "Slack",
  sherweb: "Sherweb",
  onepassword: "1Password",
  m365: "Microsoft 365",
  autotask: "Autotask",
  datto: "Datto",
  superoffice: "SuperOffice",
  google: "Google Workspace",
  gworkspace: "Google Workspace",
  threatlocker: "ThreatLocker",
  zoom: "Zoom",
  zapier: "Zapier",
  superops: "SuperOps",
  dropbox: "Dropbox",
  quickbooks: "Quickbooks",
  box: "Box",
  ninjaone: "NinjaOne",
  itglue: "ITGlue",
  ITGlue: "ITGlue",
  Acronis: "Acronis",
  Connectwise: "ConnectWise",
  connectwise: "ConnectWise",
  halo: "Halo PSA",
  Huntress: "Huntress",
};

/**
 * Get connector logo by application name
 * @param applicationName - The name of the application
 * @returns The logo URL for the connector, defaults to autotask_icon if not found
 */
export const getConnectorLogo = (applicationName: string): string => {
  const normalizedName = String(applicationName || "").toLowerCase();
  return connectorLogos[applicationName] || connectorLogos[normalizedName] || default_icon;
};

/**
 * Get connector description by application name
 * @param applicationName - The name of the application
 * @returns The description for the connector, defaults to a generic description if not found
 */
export const getConnectorDescription = (applicationName: string): string => {
  const normalizedName = String(applicationName || "").toLowerCase();
  const description = connectorDescriptions[applicationName] || connectorDescriptions[normalizedName];
  return typeof description === "string" && description.length > 0
    ? description
    : `${applicationName} integration for your business.`;
};

/**
 * Format application name for display
 * @param applicationName - The technical name of the application
 * @returns The formatted display name
 */
export const formatAppName = (applicationName: string): string => {
  const lowerName = applicationName.toLowerCase();
  return (
    appNameMapping[lowerName] ||
    applicationName.charAt(0).toUpperCase() + applicationName.slice(1)
  );
};

export type IntegrationCategoryId =
  | "psa"
  | "rmm"
  | "documentation"
  | "workplace"
  | "teamchat"
  | "licensing"
  | "passwords"
  | "security"
  | "networking"
  | "backup"
  | "scheduling"
  | "additional";

export interface IntegrationCategory {
  id: IntegrationCategoryId;
  title: string;
  shortLabel: string;
  description: string;
  scopeLabel: string;
  scopeDetail: string;
}

export const INTEGRATION_CATEGORIES: IntegrationCategory[] = [
  {
    id: "psa",
    title: "PSA ticketing",
    shortLabel: "PSA",
    description:
      "Ticketing platforms where Theo reads queues, updates tickets, posts time, and runs Auto Mode.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "rmm",
    title: "RMM devices",
    shortLabel: "RMM",
    description:
      "Device monitoring platforms where Theo reads endpoints and alerts, runs scripts, and opens secure shell sessions.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "documentation",
    title: "Documentation",
    shortLabel: "Documentation",
    description:
      "IT documentation hubs Theo searches for runbooks, passwords, and asset context during every turn.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "workplace",
    title: "Workplace",
    shortLabel: "Workplace",
    description:
      "Microsoft 365 and Google Workspace connected per customer so Theo can manage users, mail, calendars, and Drive.",
    scopeLabel: "Per customer",
    scopeDetail: "Connect each customer tenant separately.",
  },
  {
    id: "teamchat",
    title: "Team Chat",
    shortLabel: "Team Chat",
    description:
      "Team chat where Theo answers questions, posts ticket updates, and notifies technicians.",
    scopeLabel: "Per customer",
    scopeDetail: "Connect each customer workspace separately.",
  },
  {
    id: "licensing",
    title: "License Manager",
    shortLabel: "Licenses",
    description:
      "Cloud marketplace subscriptions where Theo looks up the catalog, places orders, and tracks billing.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "passwords",
    title: "Password Manager",
    shortLabel: "Passwords",
    description:
      "Team password vaults where Theo looks up and manages vault items on behalf of technicians.",
    scopeLabel: "Per customer",
    scopeDetail: "Connect each customer vault separately.",
  },
  {
    id: "security",
    title: "Security",
    shortLabel: "Security",
    description:
      "Endpoint, email, and SaaS security platforms where Theo reviews detections and incidents.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "networking",
    title: "Networking",
    shortLabel: "Networking",
    description: "Network monitoring and management platforms for switches, firewalls, and Wi-Fi.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "backup",
    title: "Backup",
    shortLabel: "Backup",
    description: "Backup and disaster recovery platforms where Theo checks backup health.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "scheduling",
    title: "Scheduling",
    shortLabel: "Scheduling",
    description: "Appointment scheduling for technicians and end users.",
    scopeLabel: "MSP level",
    scopeDetail: "One connection serves every customer.",
  },
  {
    id: "additional",
    title: "More integrations",
    shortLabel: "More",
    description: "Other integrations that do not fit the categories above.",
    scopeLabel: "Mixed",
    scopeDetail: "Connection scope depends on the integration.",
  },
];

export interface IntegrationCatalogEntry {
  key: string;
  name: string;
  category: IntegrationCategoryId;
  scope: "platform" | "application";
  platformType?: string;
  blurb: string;
}

const CATALOG_PLATFORM_TYPES: Record<string, string[]> = {
  autotask: ["psa"],
  superops: ["psa", "rmm"],
  halo: ["psa"],
  ninjaone: ["rmm"],
  connectwise: ["psa"],
  nable: ["rmm"],
  datto: ["rmm"],
  itglue: ["docs"],
  hudu: ["docs"],
  sherweb: ["marketplace"],
};

const CATALOG_PLATFORM_CATEGORY: Record<string, IntegrationCategoryId> = {
  psa: "psa",
  rmm: "rmm",
  docs: "documentation",
  marketplace: "licensing",
  edr: "rmm",
  ph: "additional",
};

const CATALOG_APPLICATION_CATEGORY: Record<string, IntegrationCategoryId> = {
  m365: "workplace",
  gworkspace: "workplace",
  slack: "teamchat",
  onepassword: "passwords",
};

export const INTEGRATION_CATALOG: IntegrationCatalogEntry[] = [
  ...Object.entries(CATALOG_PLATFORM_TYPES).flatMap(([name, types]) =>
    types.map((platformType) => ({
      key: `platform:${platformType}:${name.toLowerCase()}`,
      name,
      category: CATALOG_PLATFORM_CATEGORY[platformType] ?? "additional",
      scope: "platform" as const,
      platformType,
      blurb: getConnectorDescription(name),
    }))
  ),
  ...Object.keys(CATALOG_APPLICATION_CATEGORY).map((name) => ({
    key: `application:${name.toLowerCase()}`,
    name,
    category: CATALOG_APPLICATION_CATEGORY[name.toLowerCase()] ?? "additional",
    scope: "application" as const,
    platformType: undefined,
    blurb: getConnectorDescription(name),
  })),
];

export const getCategoryForPlatformType = (
  platformType: string | undefined | null
): IntegrationCategoryId => {
  const normalized = String(platformType || "").toLowerCase();
  return CATALOG_PLATFORM_CATEGORY[normalized] ?? "additional";
};

export const getCategoryForApplicationName = (
  applicationName: string | undefined | null
): IntegrationCategoryId => {
  const normalized = String(applicationName || "").toLowerCase();
  if (normalized in CATALOG_APPLICATION_CATEGORY) {
    return CATALOG_APPLICATION_CATEGORY[normalized];
  }
  return getConnectorLogo(normalized) !== default_icon ? "workplace" : "additional";
};

export const normalizeIntegrationName = (name: string): string =>
  String(name || "").trim().toLowerCase();

/**
 * Whether a platform/application row counts as connected. MySQL returns
 * `enabled` as 0/1, the API sometimes as boolean — accept truthy variants.
 * A row that exists but is disabled is an inactive configuration, not a
 * live connection (e.g. only one PSA platform is active at a time).
 */
export const isIntegrationEnabled = (row: { enabled?: unknown }): boolean => {
  const value = (row as { enabled?: unknown }).enabled;
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value !== 0;
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();
  return normalized === "1" || normalized === "true" || normalized === "yes";
};

/**
 * Remove catalog entries that are already connected. For per-customer
 * applications the caller passes the names connected for that customer;
 * for MSP-level platforms the caller passes connected catalog keys.
 */
export const filterOutConnectedEntries = (
  entries: IntegrationCatalogEntry[],
  connectedNames: Set<string>
): IntegrationCatalogEntry[] =>
  entries.filter((entry) => !connectedNames.has(normalizeIntegrationName(entry.name)));

export const matchesIntegrationSearch = (
  name: string,
  description: string,
  query: string
): boolean => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return (
    name.toLowerCase().includes(q) ||
    formatAppName(name).toLowerCase().includes(q) ||
    description.toLowerCase().includes(q)
  );
};

/**
 * Integrations on the roadmap. Shown in the Directory only (badged "Coming soon",
 * not clickable); deliberately kept out of INTEGRATION_CATALOG so they never
 * reach the add-integration chooser or the connect flow.
 */
export interface ComingSoonIntegration {
  key: string;
  name: string;
  category: IntegrationCategoryId;
  blurb: string;
  logo: string;
}

export const COMING_SOON_INTEGRATIONS: ComingSoonIntegration[] = [
  {
    key: "coming-soon:syncro-psa",
    name: "Syncro",
    category: "psa",
    blurb: "PSA ticketing, invoicing, and customer management for MSPs.",
    logo: syncro_icon,
  },
  {
    key: "coming-soon:connectwise-automate",
    name: "ConnectWise Automate",
    category: "rmm",
    blurb: "Remote monitoring, management, and scripted automation for endpoints.",
    logo: connectwise_automate_icon,
  },
  {
    key: "coming-soon:nable-nsight",
    name: "N-able N-sight",
    category: "rmm",
    blurb: "Cloud RMM for monitoring, patching, and remote access.",
    logo: nable_icon,
  },
  {
    key: "coming-soon:nable-ncentral",
    name: "N-able N-central",
    category: "rmm",
    blurb: "RMM for device monitoring, patch management, and automation at scale.",
    logo: nable_icon,
  },
  {
    key: "coming-soon:syncro-rmm",
    name: "Syncro RMM",
    category: "rmm",
    blurb: "Remote monitoring, patching, and scripting for managed endpoints.",
    logo: syncro_icon,
  },
  {
    key: "coming-soon:addigy",
    name: "Addigy",
    category: "rmm",
    blurb: "Apple device management for macOS, iOS, and iPadOS fleets.",
    logo: addigy_icon,
  },
  {
    key: "coming-soon:huntress",
    name: "Huntress",
    category: "security",
    blurb: "Managed EDR, ITDR, and SIEM backed by a 24/7 SOC.",
    logo: huntress_icon,
  },
  {
    key: "coming-soon:threatlocker",
    name: "ThreatLocker",
    category: "security",
    blurb: "Zero trust application allowlisting, ringfencing, and storage control.",
    logo: threatlocker_icon,
  },
  {
    key: "coming-soon:proofpoint",
    name: "Proofpoint",
    category: "security",
    blurb: "Email security, phishing protection, and security awareness training.",
    logo: proofpoint_icon,
  },
  {
    key: "coming-soon:sentinelone",
    name: "SentinelOne",
    category: "security",
    blurb: "AI-powered endpoint detection and response.",
    logo: sentinelone_icon,
  },
  {
    key: "coming-soon:saas-alerts",
    name: "SaaS Alerts",
    category: "security",
    blurb: "SaaS application monitoring and account threat response for Microsoft 365 and Google.",
    logo: saas_alerts_icon,
  },
  {
    key: "coming-soon:unifi",
    name: "Ubiquiti UniFi",
    category: "networking",
    blurb: "Network management for UniFi gateways, switches, and access points.",
    logo: unifi_icon,
  },
  {
    key: "coming-soon:auvik",
    name: "Auvik",
    category: "networking",
    blurb: "Network monitoring, mapping, and configuration backup.",
    logo: auvik_icon,
  },
  {
    key: "coming-soon:meraki",
    name: "Cisco Meraki",
    category: "networking",
    blurb: "Cloud-managed networking, security appliances, and Wi-Fi.",
    logo: meraki_icon,
  },
  {
    key: "coming-soon:datto-bcdr",
    name: "Datto BCDR",
    category: "backup",
    blurb: "Backup, disaster recovery, and business continuity appliances.",
    logo: datto_icon,
  },
  {
    key: "coming-soon:timezest",
    name: "TimeZest",
    category: "scheduling",
    blurb: "Self-service appointment scheduling linked to PSA tickets.",
    logo: timezest_icon,
  },
];
